import { Table, Text } from '@approvalmax/ui/src/components';
import { statics } from 'modules/common';
import { FC, memo, useMemo } from 'react';
import { noValue } from 'shared/constants';

import { DelegateDateCellProps } from './DelegateDateCell.types';

const DelegateDateCell: FC<DelegateDateCellProps> = memo((props) => {
    const { item, value } = props;

    const date = useMemo(() => {
        if (!value) {
            return;
        }

        const delegateTimeZone = item.delegateTimeZone
            ? statics.timeZone.findTimeZoneById(item.delegateTimeZone)
            : undefined;

        const tzShift = statics.timeZone.getOffsetShift(
            statics.timeZone.getUtcOffset(delegateTimeZone),
            statics.timeZone.getLocalUtcOffset()
        );

        return statics.timeZone.addOffset(value, tzShift);
    }, [item.delegateTimeZone, value]);

    /**
     * this is more robust way to format date-time, because moment.format('lll')
     * has a bug w/ 12h -> 24h formatting, so we should avoid using it
     */
    const formattedDate = useMemo(() => {
        if (!date) {
            return;
        }

        return date.toDate().toLocaleString(undefined, {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        });
    }, [date]);

    return (
        <Table.Cell {...props} title={formattedDate}>
            <Text font='body' wrap={false} fontSize='small'>
                {formattedDate ?? noValue}
            </Text>
        </Table.Cell>
    );
});

DelegateDateCell.displayName = 'DelegateDateCell';

export default DelegateDateCell;
